import { ArrowLeftIcon } from 'lucide-react';

import {
  MobileMenuItem,
  MobileMenuLabel,
  MobileMenuSeparator,
  MobileMenuStackScreenContent,
  useMobileMenu,
  useSimpleStackNavigator,
} from '@crossnokaye/ux-common/ckds';

import { EquipmentBrowserSection } from '@repo/sdk/models/components';

import { Button } from '@/ux-common/components/button/button';

import { JUMP_TO_MENU_ID } from './constants';
import { JumpToEquipmentReturn } from '../useJumpToEquipment';

interface JumpToEquipmentScreenProps extends JumpToEquipmentReturn {
  section: EquipmentBrowserSection;
}

export const JumpToEquipmentScreen = ({
  section,
  getEquipmentBySection,
  handleEquipmentClick,
}: JumpToEquipmentScreenProps) => {
  const { popScreen } = useSimpleStackNavigator();
  const { close } = useMobileMenu(JUMP_TO_MENU_ID);

  return (
    <MobileMenuStackScreenContent
      stickyBottom={
        <>
          <div className="flex gap-2 px-inline-sm pb-inline-sm pt-2.5">
            <Button className="btn btn-inverse flex-1" onClick={popScreen}>
              <ArrowLeftIcon className="btn-icon" aria-hidden="true" />
              Equipment Menu
            </Button>
          </div>
        </>
      }
    >
      <MobileMenuLabel>{section.name}</MobileMenuLabel>
      <MobileMenuSeparator />

      {getEquipmentBySection(section)?.map((equipment) => (
        <MobileMenuItem
          onClick={() => {
            handleEquipmentClick(equipment, section);
            close();
          }}
        >
          {equipment.title}
        </MobileMenuItem>
      ))}
    </MobileMenuStackScreenContent>
  );
};
